import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import useData from './hooks';
import { CenterItemsProps } from './types';
import { Name } from './const';
import { pureWhiteColor } from '00.app/theme';

const CenterItems: React.FC<CenterItemsProps> = ({
  pageTitle,
  children,
  showLeftMenu,
  searchView,
}: CenterItemsProps) => {
  const { t } = useTranslation('common');
  // eslint-disable-next-line no-empty-pattern
  const {} = useData();

  return !showLeftMenu ? (
    <Box
      data-cy={Name}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        px: { md: '2em', lg: '2em' },
        minWidth: 0, // autorise le shrink
        overflow: 'hidden', // cache le surplus
      }}
    >
      {children || (
        <Tooltip
          arrow
          enterDelay={400}
          title={<Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxWidth: 800 }}>{pageTitle}</Box>}
        >
          <Typography
            variant="h6"
            sx={{
              display: {
                xs: searchView ? '-webkit-box' : 'none',
                sm: searchView ? '-webkit-box' : 'none',
                md: '-webkit-box',
                lg: '-webkit-box',
                alignItems: 'center',
                textAlign: 'center',
                color: !searchView ? pureWhiteColor : 'inherit',
              },
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              fontSize: !searchView ? '1.3vw' : '1.2em',
              lineBreak: 'anywhere',
            }}
          >
            {pageTitle}
          </Typography>
        </Tooltip>
      )}
    </Box>
  ) : (
    <></>
  );
};

export default observer(CenterItems);
